export * from "./components/search-result";
export * from "./components/search";
export * from "./services/search.service";
export * from "./search.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/search/index.js
// module id = 214
// module chunks = 0